export const CHAT_RULE_PREFIX = 'chat';
export var Chat;
(function (Chat) {
    Chat["Report"] = "chat:report";
    Chat["MessageTime"] = "chat:message-time";
    Chat["Moderate"] = "chat:moderate";
    Chat["Pin"] = "chat:pin";
    Chat["Block"] = "chat:block";
})(Chat || (Chat = {}));
